export const preconnectLinks = [
    "assets.hermes.com",
    "www.googletagmanager.com",
    "sdk.privacy-center.org",
];

export const chinaPreconnectLinks = [
    "assets.hermes.cn",
    "www.googletagmanager.com",
];
